import { Disclaimer, Flex, theme } from 'modules/ui';
import styled from 'styled-components';

export const InputWithDisclaimerWrapper = styled(Flex)`
  > * {
    margin-bottom: 0;
  }
`;

export const StyledDisclaimer = styled(Disclaimer)`
  margin-top: 0.375rem;
  color: ${theme.colors.primaryK7};
`;
